import { atom } from 'recoil';

const countryErrorAtom = atom({
  key: 'countryError',
  default: { Name: '', InternationalCode: '', Order: '' }
});

export { countryErrorAtom };
